import styled from '@emotion/styled'

export default styled.div`
	margin: 0 auto;
	max-width: 1400px;
`
